import { Search } from 'lucide-react';
import React, { useState } from 'react';

const Sidebar = ({ isOpen, files, filesError, selectedSlide, onLoadSlide, activeSlideRef, plotProps, StatsPlot }) => {
  // --- NEW: State to hold the search term ---
  const [searchTerm, setSearchTerm] = useState('');

  // --- NEW: Filter files based on the search term ---
  const filteredFiles = files.filter(fileInfo =>
    fileInfo.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    // On mobile (default): fixed, inset-0, high z-index, invisible and no pointer events when closed.
    // On desktop (md:): static position, part of the flex flow, visible.
    <aside className={`
        bg-gray-50 dark:bg-gray-800 shadow-lg flex flex-col h-full 
        transition-transform duration-300 ease-in-out
        fixed lg:static inset-y-0 left-0 z-30
        w-72 lg:w-96 xl:w-fit
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        lg:translate-x-0
        ${isOpen ? 'lg:flex' : 'lg:hidden'}
      `}>
        <div className="p-4 flex-shrink-0 border-b dark:border-gray-700">
          <div className="p-4 border-b dark:border-gray-700 flex flex-row items-center space-x-2">
            <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200 w-fit hidden lg:block">Available Slides</h2>
            <div className="flex-grow" />
            {/* --- NEW: Search input field --- */}
            <input
              type="text"
              placeholder="Search slides..."
              className="mx-px-3 py-2 text-sm text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search className="flex m-2 mt-3 text-gray-400" size={16} />
            </div>
          {filesError && <div className="text-red-500 text-sm mt-2">Error: {filesError}</div>}
        </div>

        {/* --- NEW: Search bar section --- */}
        

        <div className="flex-1 overflow-y-auto custom-scrollbar p-4">
          {/* --- MODIFIED: Logic to handle no files, no search results, or display filtered files --- */}
          {files.length === 0 && !filesError ? (
            <p className="text-gray-500 dark:text-gray-400 text-sm">No .mrxs files found.</p>
          ) : filteredFiles.length === 0 ? (
            <p className="text-gray-500 dark:text-gray-400 text-sm">No matching slides found.</p>
          ) : (
            <ul className="space-y-2">
              {/* --- MODIFIED: Map over `filteredFiles` instead of `files` --- */}
              {filteredFiles.map((fileInfo, index) => {
                const isSelected = selectedSlide === fileInfo.path;
                return (
                  <li
                    key={index}
                    ref={isSelected ? activeSlideRef : null}
                    className={`rounded-lg transition-colors ${isSelected ? 'bg-blue-100 dark:bg-blue-900' : ''}`}
                  >
                    <button onClick={() => onLoadSlide(fileInfo.path)} className="w-full text-left px-3 py-2 hover:bg-blue-50 dark:hover:bg-blue-800 transition-colors text-gray-700 dark:text-gray-300 text-sm group" title={fileInfo.path}>
                      <div className="flex justify-between items-center">
                        <span className="truncate pr-2 font-medium">{fileInfo.name}</span>
                        <div className="flex space-x-2 flex-shrink-0">
                          {fileInfo.has_db_data && <span className="text-xs bg-green-200 text-green-800 font-medium px-2 py-0.5 rounded-full">cells</span>}
                          {fileInfo.has_contours && <span className="text-xs bg-orange-200 text-green-800 font-medium px-2 py-0.5 rounded-full">json</span>}
                        </div>
                      </div>
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
  
        {/* --- Conditionally render the plot at the bottom of the sidebar on large screens --- */}
          <div className="hidden lg:inline flex-shrink-0 p-4 border-t dark:border-gray-700 bg-gray-100 dark:bg-gray-900">
             <h3 className="text-base font-semibold text-gray-800 dark:text-gray-200 mb-2">Slide Statistics</h3>
             {/* The StatsPlot component is now rendered here */}
             <StatsPlot {...plotProps} />
          </div>
      </aside>
    );
  };
  

export default Sidebar;